// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationSummaryResponse
 */
export interface NotificationSummaryResponse {
    /**
     * Id of the newest notification, or null when none exist.
     * @type {string}
     * @memberof NotificationSummaryResponse
     */
    latestId?: string | null;
    /**
     * Total notifications for the user.
     * @type {number}
     * @memberof NotificationSummaryResponse
     */
    totalCount?: number;
    /**
     * Unread notifications for the user.
     * @type {number}
     * @memberof NotificationSummaryResponse
     */
    unreadCount: number;
}

/**
 * Check if a given object implements the NotificationSummaryResponse interface.
 */
export function instanceOfNotificationSummaryResponse(value: object): value is NotificationSummaryResponse {
    if (!('unreadCount' in value) || value['unreadCount'] === undefined) return false;
    return true;
}

export function NotificationSummaryResponseFromJSON(json: any): NotificationSummaryResponse {
    return NotificationSummaryResponseFromJSONTyped(json, false);
}

export function NotificationSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'latestId': json['latestId'] == null ? undefined : json['latestId'],
        'totalCount': json['totalCount'] == null ? undefined : json['totalCount'],
        'unreadCount': json['unreadCount'],
    };
}

export function NotificationSummaryResponseToJSON(json: any): NotificationSummaryResponse {
    return NotificationSummaryResponseToJSONTyped(json, false);
}

export function NotificationSummaryResponseToJSONTyped(value?: NotificationSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latestId': value['latestId'],
        'totalCount': value['totalCount'],
        'unreadCount': value['unreadCount'],
    };
}
